import React from 'react';
import Icon from 'components/lib/icons/icon';

export default function CloseLineIcon(props) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M18 6L6 18M6 6l12 12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </Icon>
  );
}
